export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const PRODUCTION_HOST_NAME = 'maps.advoc8.co';
